import { isAfter } from "date-fns"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementTerminated_Agreement on AgreementType {
            validFrom
            validTo
        }
    `),
}

type IsAgreementTerminatedProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementTerminated(props: IsAgreementTerminatedProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    if (!agreement.validTo) {
        return false
    }

    // agreement under activation has equal validTo / validFrom values
    if (agreement.validTo === agreement.validFrom) {
        return false
    }

    return isAfter(new Date(), new Date(agreement.validTo))
}

isAgreementTerminated.fragments = graphQLFragments
